import React, { useEffect, useState } from "react";
import { useCMContext } from "../../../services/contexts/companyManagement/CMContext";
import { getDepositorySheetHistroy } from "../../../services/apis/shareManagement/InventoryAPI";
import { useLogin } from "../../../services/contexts/AdminLoginContext";
import { Link } from "@material-ui/core";
import { configs } from "../../../assets/Config";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";

export default function DInventoryReportsPage() {

    const { showReport, setShowReport } = useCMContext();
    const { setShowSuccess, token, logout, setLoginError, setCurrModule, allowedFunc } = useLogin()

    const [historyId, setHistoryId] = useState("");
    const [reportData, setReportData] = useState("");
    const [error, setError] = useState("");
    const [loadingReport, setLoadingReport] = useState(false);

    useEffect(() => {
        try {
            setReportData("");
            getHistory(historyId)
        } catch (error) {
            console.error(error);
        }
    }, [historyId])

    async function getHistory(historyId) {
        try {
            setLoadingReport(true);
            let response = await getDepositorySheetHistroy(token, historyId);
            if (response && response.status === 200) {
                setReportData(response.data.data.report ? response.data.data.report : response.data.data);
            } else if (response && response.status === 401) {
                logout();
                setLoginError(configs.unauthorizedErrorMessage);
            }
            else {
                setError(response.data.error)
                setReportData([])
            }

        } catch (error) {
            console.error(error);
            setError("History/Details of saved records could not be fetched.")
        } finally {
            setLoadingReport(false);
        }
    }

    const columns = [{ field: "id", headerName: "Row Id", minWidth: 150, flex: 0.5, hide: true, filterable: false },
    {
        field: "isin", headerName: "ISIN", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
            return params.row.company.isin
        }, valueGetter: (value) => value.row.company.isin
    },
    {
        field: "asset_class", headerName: "Asset Class", minWidth: 150, flex: 0.5, hide: true, cellClassName: "break-text", renderCell: (params) => {
            return params.row.company.asset_class
        }, valueGetter: (value) => value.row.company.asset_class
    },
    {
        field: "company_name", headerName: "Company Name", minWidth: 150, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            return params.row.company.name
        }, valueGetter: (value) => value.row.company.name
    },
    {
        field: "action_date", headerName: "Action Date", minWidth: 150, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            return params.row.toUpdate.action_date
        }, valueGetter: (value) => value.row.toUpdate.action_date
    },
    {
        field: "depository_reference_number", headerName: "Depository Reference Number", minWidth: 100, flex: 0.4, cellClassName: "break-text", renderCell: (params) => {
            return params.row.toUpdate.depository_reference_number
        }, valueGetter: (value) => value.row.toUpdate.depository_reference_number
    },
    {
        field: "order_id", headerName: "Order Id", minWidth: 90, flex: 0.2, cellClassName: "break-text", renderCell: (params) => {
            return params.row.order.id
        }, valueGetter: (value) => value.row.order.id
    },
    {
        field: "quantity", headerName: "Quantity", minWidth: 90, flex: 0.2, cellClassName: "break-text text-right", renderCell: (params) => {
            return params.row.order.quantity
        }, valueGetter: (value) => value.row.order.quantity
    },
    {
        field: "client_id", headerName: "Client Id", minWidth: 100, flex: 0.4, cellClassName: "break-text", renderCell: (params) => {
            return params.row.user.client_id
        }, valueGetter: (value) => value.row.user.client_id
    },
    { field: "row_status", headerName: "Row Status", minWidth: 80, flex: 0.3, cellClassName: "break-text" },
    { field: "message", headerName: "Message", minWidth: 250, flex: 0.5, cellClassName: "break-text" },
    {
        field: "client_email", headerName: "E-mail", minWidth: 250, flex: 0.5, cellClassName: "break-text f-12", renderCell: (params) => {
            if (allowedFunc.includes(configs.functionList['user_management:load_user_details'])) {
                return <Link to={`/customerProfile/${params.row.user.id}`} >{params.row.user.email}</Link>
            } else {
                return params.row.user.email
            }
        }, valueGetter: (value) => value.row.user.email
    },
    ]


    const reportColumns = [{ field: "id", headerName: "Report Id", minWidth: 150, flex: 0.5, hide: true, filterable: false },
    {
        field: "admin_name", headerName: "Admin Name", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
            return params.row.admin.name
        }, valueGetter: (value) => value.row.admin.name
    },
    {
        field: "admin_email", headerName: "Admin Email", minWidth: 150, flex: 0.5, hide: true, cellClassName: "break-text", renderCell: (params) => {
            return params.row.admin.email
        }, valueGetter: (value) => value.row.admin.email
    },
    {
        field: "date", headerName: "Date", minWidth: 150, flex: 0.5, cellClassName: "break-text"
    },
    { field: "time", headerName: "Time", minWidth: 150, flex: 0.5, cellClassName: "break-text" },
    {
        field: "review", headerName: " ", minWidth: 100, flex: 0.2, cellClassName: "text-primary break-text", filterable: false, renderCell: (params) => {
            const isLoading = loadingReport && historyId === params.row.id
            return <a href="" className="custom-link" onClick={(e) => {
                e.preventDefault();
                if (loadingReport) return;
                setHistoryId(params.row.id);
            }}>{isLoading ? "Loading..." : "Detailed Report"}</a>
        }
    }
    ]

    return (
        <div id="inventoryAnalyticsListPage" style={{ width: "100%" }}>
            <div className="row d-flex align-items-center mt-2 ml-3 mb-1 mr-2">
                <div className="col-md-12 col-12 p-0">
                    <p className="h4 text-custom-grey">{historyId ?
                        <i className="far fa-arrow-alt-circle-left curPoint" onClick={(e) => {
                            setHistoryId("");
                        }}></i>
                        : null} Depository Update Report {historyId ? `Detail - ${historyId}` : ""}</p>
                </div>
            </div>
            <div className='row m-0 mx-3 p-0'>
                <div className='col-6 m-0 p-0'>
                    <a href='#' className='custom-link' onClick={(e) => {
                        e.preventDefault()
                        setShowReport(false);
                    }}><p className='m-0 p-0'>View Processed Data</p></a>
                </div>
                <div className='col-6 m-0 p-0 d-md-none d-block'>
                    <a href='#' className='custom-link' onClick={(e) => {
                        e.preventDefault()
                        document.getElementById("updateExportInventory").classList.toggle('d-none')
                        document.getElementById("inventoryAnalyticsListPage").classList.toggle('d-none')
                    }}><p className='m-0 p-0'>Update Depository Data</p></a>
                </div>
            </div>
            <div className="deleted-role-table">
                {loadingReport ? <div className="loader"></div> : reportData && reportData.length > 0 && historyId ? <DataGrid
                    rows={reportData}
                    headerHeight={40}
                    rowHeight={30}
                    columns={columns}
                    resizable={true}
                    autoPageSize
                    pagination
                    components={{
                        Toolbar: GridToolbar,
                    }} /> : reportData && reportData.length > 0 ? <DataGrid
                        rows={reportData}
                        headerHeight={40}
                        rowHeight={30}
                        columns={reportColumns}
                        resizable={true}
                        autoPageSize
                        pagination
                        components={{
                            Toolbar: GridToolbar,
                        }} /> : <p className={`pt-5 ${error ? "text-danger" : ""}`}>{error ? error : "No Report Data to check."}</p>}
            </div>
        </div>
    )
}